import { Box, Button, Text, Tooltip } from '@chakra-ui/react';
import { ReactElement } from 'react';

type ConsentimentoStatus =
  | 'NOT_SENT'
  | 'SENT'
  | 'NOT_ALLOWED_BY_CLIENT'
  | 'ALLOWED_BY_CLIENT'
  | 'CONTACT_ERROR'
  | 'REACHED_CONSENT_REQUEST';

type ConsentimentoButtonProps = {
  loading?: boolean;
  variant?: 'primary' | 'secondary' | 'error' | 'success' | 'warning';
  children: any;
  onClick?: () => void;
  disabled?: boolean;
  tooltip?: string | undefined;
};

const variantColors = {
  primary: '#00335E',
  secondary: '#FFFFFF',
  error: '#FFFFFF',
  success: '#43C677',
  warning: '#FFF6A4'
};

const textColors = {
  primary: '#FFFFFF',
  secondary: '#00335E',
  error: '#AA2C23',
  success: '#FFFFFF',
  warning: '#000000'
};

const border = {
  primary: 'none',
  secondary: 'solid 1px #00335E',
  error: 'solid 1px #AA2C23',
  success: '#43C677',
  warning: 'none'
};

export const ConsentimentoButton = ({
  children,
  variant = 'secondary',
  loading = false,
  disabled = false,
  tooltip,
  onClick
}: ConsentimentoButtonProps) => {
  return (
    <Box>
      <Button
        bg={variantColors[variant]}
        color={textColors[variant]}
        fontSize=".7rem"
        border={border[variant]}
        w="100%"
        h="2.1rem"
        isLoading={loading}
        onClick={onClick}
        pointerEvents={disabled ? 'none' : 'auto'}
        m="0 !important"
        _hover={{
          opacity: '1'
        }}
      >
        {children}
      </Button>
    </Box>
  );
};
